import React, { Component } from 'react';
import {
  Badge,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable2 from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ReactHtmlParser from 'react-html-parser';
import Loader from '../../../commons/loader';
import Service from './services';
import { PaginationTotal } from '../../../commons/controls';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import RFField from '../../../components/Form/RFField';
import RFForm from '../../../components/Form/RFForm';
import Lib from '../../../commons/lib';

class HelyszinContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      angolNyelv: false,
      currentRow: {},
      helyszinJson: [],
      modalHelyszin: false,
      modalHelyszinTorles: false,
      modalHelyszinModosit: false,
      helyszinModositObj: {},
      modalNezet: false,
      mezoJson: {},
      helyszin: {},
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'LOAD',
      statusz: [],
      statuszOptions: [],
      filterOptions: {},
    };
    this.options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };
  }

  componentDidMount() {
    this.checkAngolNyelv();
  }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      if (this.props.active) this.updateTable();
    }
  }

  checkAngolNyelv = () => {
    Service.getAngolNyelv((err, res) => {
      if (!err) {
        this.setState({ angolNyelv: res[0] });
      }
    });
  }

  hasRoleKarb = () => {
    if (this.props.globals.hasRole(['HELYSZIN_HELYSZIN'], true)) return true;
    return false;
  }

  handleHelyszinEditClick = (id) => {
    this.props.globals.route.navigate(this.props.globals.public_url.concat("/admin/torzsadatok/helyszin/modositas?id=" + id));
  }

  handleHelyszinDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleHelyszinTorles();
  }

  handleViewClick = (id) => {
    Service.viewHelyszin(id, (err, res) => {
      if (!err) {
        this.setState({ mezoJson: res[0].metaadatok, helyszin: res[0] });
        this._currentViewId = id;
        this.toggleNezet();
      } 
    });
  }

  iconFormatter = (cell) => {
    return (
      <div>
        {
          <React.Fragment>
            <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekintes'} onClick={() => this.handleViewClick(cell)} />
            {this.hasRoleKarb()
              ? (
                <React.Fragment>
                  <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleHelyszinEditClick(cell)} />
                  <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleHelyszinDeleteClick(cell)} />
                </React.Fragment>
              )
              : <div />}
          </React.Fragment>
        }
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'megtekintes'} delay={0}>Megtekintés</UncontrolledTooltip>
        {this.hasRoleKarb()
          ? (
            <div>
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
            </div>
          ) : <div />}
      </div>
    );
  }

  statuszFormatter = (cell) => {
    let statusz = this.state.statusz.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }

  updateTable = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Service.listHelyszin((err, res) => {
        if (!err) {
          let filters = {};
          let options = res[0].statusz.map((e) => {
          filters[e.name] = e.caption;

          return <option key={e.name} value={e.name}>{e.caption}</option>;
        });
          
          this.setState({
            helyszinJson: res[0].list,
            tableStatus: res[0].list.length > 0 ? 'TABL' : 'DATA',
            statusz: res[0].statusz,
            statuszOptions: options,
            filterOptions: filters
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  toggleNezet = () => {
    this.setState((prevState) => { return ({ modalNezet: !prevState.modalNezet }); });
  }

  toggleHelyszin = () => {
    this.setState((prevState) => { return ({ modalHelyszin: !prevState.modalHelyszin, currentColor: '' }); });
  }

  toggleHelyszinModosit = () => {
    this.setState((prevState) => { return ({ modalHelyszinModosit: !prevState.modalHelyszinModosit }); });
  }

  toggleHelyszinTorles = () => {
    this.setState((prevState) => { return ({ modalHelyszinTorles: !prevState.modalHelyszinTorles }); });
  }

  addHelyszin = (event, helyszinObj) => {
    Service.addHelyszin(helyszinObj, (err) => {
      if (!err) {
        this.toggleHelyszin();
        this.updateTable();
        this.props.globals.addSuccess('Helyszín hozzáadva!');
      }
    })
  }

  deleteHelyszin = () => {
    this.toggleHelyszinTorles();
    Service.deleteHelyszin(this._currentDeleteId, (err) => {
      if (!err) {
        this.updateTable();
        this.setState({ currentRow: [] });
        this.props.globals.addSuccess('Helyszín törölve!');
      }
    });
  }

  deleteMetaadat = (mezonev) => {
    delete this.state.mezoJson[mezonev];
    this.setState({ mezoJson: this.state.mezoJson });
  }

  renderMezok = () => {
    let mezok = [];
    for (let mezonev in this.state.mezoJson) {
      mezok.push(<div key={mezonev}><b>{mezonev}: </b>{this.state.mezoJson[mezonev]}<br /></div>);
    }
    return mezok;
  }

  isEmpty = (obj) => {
    for (var key in obj)
      if (obj.hasOwnProperty(key)) return false;
    return true;
  }

  renderAdatok = (id) => {
    return (
      <div>
        <b>Helyszín típus: </b>{this.state.helyszin.tipus}<br />
        {this.state.helyszin.cegadat && (
          <div><b>Cégadat: </b>{this.state.helyszin.cegadat}<br /></div>
        )}
        <b>Helyszín név: </b>{this.state.helyszin.nev}<br />
        <b>Helyszín azonosító: </b>{this.state.helyszin.azonosito}<br />
        <b>Központ: </b>{this.state.helyszin.kozpont === true ? "Igen" : this.state.helyszin.kozpont === false ? "Nem" : "Üres"}<br />
        <b>Email: </b>{this.state.helyszin.email}<br />
        <b>Telefonszám: </b>{this.state.helyszin.telefon}<br />
        <b>Weboldal: </b>{this.state.helyszin.honlap}<br />
        <b>Adatvédelmi tájékoztató: </b>{this.state.helyszin.adatvedelmiurl}<br />
        <b>Cím: </b>{this.state.helyszin.cim}<br />
        <b>Állapot: </b>{this.state.helyszin.allapot}<br />
        <b>Leírás: </b>{ReactHtmlParser(this.state.helyszin.leiras)}<br />
        {this.state.angolNyelv == true ?
          <div><b>Leírás (angol): </b>{ReactHtmlParser(this.state.helyszin.leirasangol)}<br /></div>
          : <div />
        }
        {!this.isEmpty(this.state.mezoJson) &&
          <div>
            <br />
            <h5>Kiegészítő adatok:</h5>
            <div>{this.renderMezok()}</div>
          </div>
        }
      </div>
    );
  }

  renderTable = () => {
    const columns = [
      {
        dataField: 'nev',
        text: 'Helyszín neve',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'email',
        text: 'Email',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...'
        }),
        sort: true
      },
      {
        dataField: 'telefon',
        text: 'Telefonszám',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'honlap',
        text: 'Weboldal',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'allapot.name',
        align: 'center',
        text: 'Állapot',
        filter: selectFilter({
          options: this.state.filterOptions,
          placeholder: 'Összes',
          condition: 'eq'
        }),
        sort: true,
        formatter: this.statuszFormatter
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        data={this.state.helyszinJson}
        columns={columns}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
    );

  }

  navToAdd = () => {
    this.props.globals.route.navigate(this.props.globals.public_url.concat('/admin/torzsadatok/helyszin/felvitel'));
  }

  render() {
    return (
      <div>
        <div className="row">
          {
            this.hasRoleKarb()
              ? (
                <div className="col-sm-12">
                  <Button className="pull-left table-new-button" color="primary" onClick={this.navToAdd}>Új helyszín hozzáadása</Button>
                </div>
              )
              : <div />
          }
        </div>
        {this.state.tableStatus === 'TABL' ? this.renderTable() : this.state.tableStatus === 'NETW' ? <NetworkEmptyState hasImage submitClick={this.updateTable} /> : this.state.tableStatus === 'DATA' ? <DataEmptyState hasImage submitClick={this.updateTable} /> : <Loader />}
          <RFForm
            onSubmit={this.addHelyszin}
            modalInsert
            title={'Helyszín felvétel'}
            tagProps={{ isOpen: this.state.modalHelyszin, toggle: this.toggleHelyszin, className: this.props.className, backdrop: 'static' }}
            footer={
              <React.Fragment>
                <Button type='submit' color="primary">Mentés</Button>{' '}
                <Button type="button" color="secondary" onClick={this.toggleHelyszin}>Mégsem</Button>
              </React.Fragment>
            }
          >
                <RFField
                  label={'Azonosító: *'}
                  name="azonosito"
                  id="azonosito"
                  regex={['/^.{10}$/', 'Maximum 10 mező!']}
                  // validate={{
                  //   maxLength: { value: 10 }
                  // }}
                  required
                />
                <RFField
                  label={'>Helyszín neve: *'}
                  name="nev"
                  id="nev"
                  regex={['/^.{10}$/', 'Maximum 10 mező!']}
                  // validate={{
                  //   maxLength: { value: 50 }
                  // }}
                  required
                />
          </RFForm>
        <Modal isOpen={this.state.modalHelyszinTorles} toggle={this.toggleHelyszinTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a helyszínt?</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteHelyszin}>OK</Button>
            <Button type="button" color="secondary" onClick={this.toggleHelyszinTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalNezet} toggle={this.toggleNezet} className={this.props.className} backdrop="static">
          <ModalHeader >Helyszín információ</ModalHeader>
          <ModalBody>{this.state.modalNezet ? this.renderAdatok(this._currentViewId) : <div />}</ModalBody>
          <ModalFooter> <Button type="button" color="primary" onClick={this.toggleNezet}>Vissza</Button></ModalFooter>
        </Modal>
      </div>
    );
  }

};

export default HelyszinContent;
